import React from "react";
import axios from "axios";
import * as IoIcons from "react-icons/io";

function DequipoOdontologiaEspecializada({ id, onSuccess }) {
  const postRemove = (e) => {
    e.preventDefault();

    if (!window.confirm("¿Está seguro de eliminar este registro?")) return;

    axios
      .delete(
        "https://suadesarrollo.azurewebsites.net/api/EliminaOdontologiaEspecializada/" +
          id,
      )
      .then(() => {
        alert("Eliminado con éxito");
        onSuccess && onSuccess(); // 🔄 recarga tabla
      })
      .catch((error) => {
        console.log(error);
        alert("Error al eliminar");
      });
  };

  return (
    <button className="btn btn-danger" onClick={postRemove}>
      <IoIcons.IoIosCloseCircleOutline size={20} />
    </button>
  );
}

export default DequipoOdontologiaEspecializada;
